/*
 * answer.js
 */

// import jQuery from 'jquery';  //node_modlesの中にあるものを使用探しに行ってくれる
import $ from 'jquery';
import 'jquery.cookie';
import 'slick-carousel';
import '../scss/style.scss';

$(function(){
/* ==========================================================
!for Answer
========================================================== */
  /* ロゴ用スライド
  -------------------------------------------------- */
	var $slider = $('.js-answer-precedent-logo');
	let slidesToShowNum = 5; //slidesToShowに設定したい値
	/* slidesToShowより投稿が少ない場合の処理を記述 */
	let slidesItem = $('.js-answer-precedent-logo .slick-slide').length; //スライド内の画像の個数を取得
	if (slidesItem <= slidesToShowNum) {
		for (let i = 0; i <= slidesToShowNum + 1 - slidesItem; i++) { //足りていない要素数分、後ろに複製
			$('.js-answer-precedent-logo .slick-slide:nth-child(' + i + ')').clone().appendTo($slider);
		}
	}
  $slider.slick({
    autoplay: true,
    autoplaySpeed: 2000,
    arrow: true,
    cssEase: 'linear',
    dots: true,
    pauseOnFocus: false,
    pauseOnHover: false,
    speed: 500,
    slidesToScroll: 1,
    slidesToShow: slidesToShowNum,
    appendDots: $('.slick-controler'),
    appendArrows: $('.slick-controler'),
    responsive: [
      {
        breakpoint: 768,
        settings: {
          centerMode: true,
          centerPadding: '60px',
          slidesToShow: 1,
          variableWidth: true,
        },
      },
    ],
  });
  $(".js-answer-precedent-logo__pause").on("click", function() {
    //一時停止中なら
    if($(this).hasClass("paused")){
      //再開
      $(".js-answer-precedent-logo").slick("slickPlay");
      //「.paused」削除
      $(this).removeClass("paused");
    }else{
      //再生中なら
      //一時停止
      $(".js-answer-precedent-logo").slick("slickPause");
      //「.paused」付与
      $(this).addClass("paused");
    }
  });

});
